export type GetContainer = HTMLElement | (() => HTMLElement) | null;

export function resolveContainer(container: HTMLElement | (() => HTMLElement) | string | undefined | null) {
  if (typeof container === 'string') {
    return document.querySelector(container) || document.body;
  } else {
    const containerElement = typeof container === 'function' ? container() : container;
    return containerElement || document.body;
  }
}
